export default __webpack_public_path__ + "static/media/September2013.c3e101cb.png";